import React, {useEffect, memo} from "react";

import {ThemeProvider, AppBar, Container, Toolbar, Typography } from '@mui/material';
import {ThemeCustom} from '../../styles/Theme';
import './nav_bar.scss';

import LogoutIcon from '../../assets/logout.svg'
import ButtonMain from "../button/Button_main";
import ButtonImgMain from "../button/Button_img_main";

import Trash from '../../assets/trash.svg'
import Import from '../../assets/import.svg'

const FooterBarReveiw = (props) => {

    useEffect(()=>{console.log('props', props)},[props])

    return(
        <ThemeProvider theme={ThemeCustom}>
            <AppBar position="fixed" className="shadow-none bottom-0 top-auto">
                <Container maxWidth="xl">
                    <Toolbar disableGutters className={`flex ${props.buttonRightDel ? 'justify-between' : 'justify-end'} items-center py-5`}>
                        { props.buttonRightDel ? (
                            <div className="flex items-center">
                                <ButtonImgMain 
                                    variant='redOutline' 
                                    type='button' 
                                    disabled={false} 
                                    name={`Delete Selected`}
                                    class='capitalize mr-3'
                                    onClick={()=>props.delAll()}
                                    img={Trash}
                                />
                                <ButtonImgMain 
                                    variant='primaryOutline' 
                                    type='button' 
                                    disabled={false} 
                                    name={`Export Selected`}
                                    class='capitalize mr-3'
                                    onClick={()=>props.download()}
                                    img={Import}
                                />
                                <Typography component={'div'} variant="textBase" className="ml-5">{props.selectedCount > 1 ? `${props.selectedCount} Resumes Selected` : props.selectedCount === 1 ? `${props.selectedCount} Resume Selected` : ''}</Typography>
                            </div>
                            ):''
                        }
                        <div className="text-primary font-sans font-bold text-3xl">
                            { props.btnOutline?(
                                <ButtonMain 
                                    variant='primaryOutline' 
                                    type='button' 
                                    disabled={false} 
                                    name={`${props.btnOutline? props.btnOutline:'Cancel'}`}
                                    class='capitalize mr-3'
                                    onClick={()=>props.cancel()}
                                />
                                ):'' 
                            }
                            {props.tab === 0 ? (
                                <>
                                    <ButtonMain 
                                        variant='red' 
                                        type='button' 
                                        disabled={false} 
                                        name={props.autoEmailEnable ? `Reject & Reply` : 'Reject'}
                                        class='capitalize mr-3'
                                        onClick={()=>props.reject()}
                                    />
                                    {props.shortlist? (
                                        <ButtonMain 
                                            variant='green' 
                                            type='submit' 
                                            disabled={false} 
                                            name={props.autoEmailEnable ? `Shortlist & Reply` : 'Shortlist'}
                                            class='capitalize'
                                            onClick={()=>props.shortlist()}
                                        />
                                    ):''}
                                </>
                            ):''}
                        </div>
                    </Toolbar>
                </Container>
            </AppBar>
        </ThemeProvider>
    )
}

export default memo(FooterBarReveiw);